/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Even_Osprey_SavorInputs */

const fr_close_even_osprey_savor = /** @type {(inputs: Close_Even_Osprey_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat trouvé`)
};

/**

* @param {Close_Even_Osprey_SavorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const close_even_osprey_savor = /** @type {((inputs?: Close_Even_Osprey_SavorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Even_Osprey_SavorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_close_even_osprey_savor(inputs)
});